import { render, staticRenderFns } from "./SectionLegendPanel.vue?vue&type=template&id=58bd3f4a&scoped=true&"
import script from "./SectionLegendPanel.vue?vue&type=script&lang=js&"
export * from "./SectionLegendPanel.vue?vue&type=script&lang=js&"
import style0 from "./SectionLegendPanel.vue?vue&type=style&index=0&id=58bd3f4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bd3f4a",
  null
  
)

export default component.exports